import { css } from '@emotion/core';
import { media } from '@domain-group/fe-brary';
export var CONTENT_WIDTH = '1020px';
export var PAGE_MARGINS = '16px';
export var pageContainer = /*#__PURE__*/css("display:flex;flex-direction:column;align-items:center;padding-bottom:116px;", media('>=tablet'), "{padding-bottom:48px;}");
export var bodySection = /*#__PURE__*/css("width:100%;align-self:center;padding:0 ", PAGE_MARGINS, ";", media('>=desktop'), "{max-width:calc(", CONTENT_WIDTH, " + ", PAGE_MARGINS, " * 2);}");
export var fullWidth = {
  name: "4rmlxi",
  styles: "width:100%;display:flex;flex-direction:column;"
};